import { STORAGE_KEYS } from './app-constants';
import { logger } from './logger';

/**
 * Storage that belongs to the signed-in person (#108). Device preferences
 * (UI language, layout, parse settings, gateway URL) are deliberately absent.
 * The keys are the owners' own constants (#115), so a renamed key is cleared too.
 */
const PERSON_LOCAL_KEYS = [
  STORAGE_KEYS.RECENT_DOCUMENTS,
  STORAGE_KEYS.PROCESSED_DOCUMENTS,
];
const PERSON_SESSION_KEYS = [
  STORAGE_KEYS.INTENDED_ROUTE,
  STORAGE_KEYS.RESTORE_DOCUMENT,
  STORAGE_KEYS.LOGIN_REDIRECTS,
];

export function clearPersonData(): void {
  for (const [storage, keys] of [
    [() => window.localStorage, PERSON_LOCAL_KEYS],
    [() => window.sessionStorage, PERSON_SESSION_KEYS],
  ] as const) {
    for (const key of keys) {
      try {
        storage().removeItem(key);
      } catch (error) {
        logger.warn('Could not clear stored data:', key, error);
      }
    }
  }
}
